export default __webpack_public_path__ + "static/media/virtual_services_photo_en.ea8cd8a2.png";